/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  // newImageSrc is the path of the new image in the same size as originalImage is sized.
  // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
  // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
  jQuery(mainImageDomEl).parents('a').attr('href', newImageSrc.replace('_grande', '_1024x1024'));
  jQuery(mainImageDomEl).attr('src', newImageSrc);  
};

jQuery(function($) {
                    
  /* Placeholder JS */
  /*==========================*/
  var test = document.createElement('input');
  if (!('placeholder' in test)) {
    $('[placeholder]').each(function(){
      if ($(this).val() === '') {
        var hint = $(this).attr('placeholder');
        $(this).val(hint).addClass('hint');
      }
    });
    $('[placeholder]').focus(function() {
      if ($(this).val() === $(this).attr('placeholder')) {
        $(this).val('').removeClass('hint');
      }
    }).blur(function() {
      if ($(this).val() === '') {
        $(this).val($(this).attr('placeholder')).addClass('hint');
      }
    });    
  }
  
  //set main content padding by the height of the header --- sticky header ======================>
  
  let header = document.getElementsByTagName('header')[0];
  let main_content_padding = header.offsetHeight;
  let main_content = document.getElementsByTagName('main')[0];
  main_content.style.paddingTop = main_content_padding + "px";
  
  // search functionality
  
  let search_icon = document.querySelector('.search-icon');
  main_content.addEventListener('click', hideSearch);
  search_icon.addEventListener('click', showSearch);
  
  function showSearch(){
    let search_box = document.querySelector('.search');
    let search_input = document.getElementById('search__input');
    if(!search_box.classList.contains('search--active')){
      search_box.classList.add('search--active');
      search_input.focus();
    }else{
      hideSearch();
    }
  }
  function hideSearch(){
  let search_box = document.querySelector('.search');
    if (search_box.classList.contains('search--active')){
      search_box.classList.remove('search--active');
    }
  }

  jQuery('.sort-by')
  .val('')
       .on('change', function() {
    Shopify.queryParams.sort_by = jQuery(this).val();
    location.search = jQuery.param(Shopify.queryParams).replace(/\+/g, '%20');
  });
  
  jQuery('.option--size').on('change', function(){
    let value = this.value;
    let $variantSelector = $(this).closest('.product-item__variants').find('.variant-selector');
    if(value != $variantSelector.find('option:selected').data('variantTitle')){
      let valToSelect = $variantSelector.find('option[data-variant-title="'+value+'"]').val();
      $variantSelector.val(valToSelect);
    }
  });
  
  jQuery('.product-item__variant').on('click', function(){
    if(!$(this).hasClass('selected') && !$(this).hasClass('unavailable')){
      let $container = $(this).parents('.product-item'),
          $price = $container.find('.product-item__product-price'),
          $compareprice = $container.find('.product-item__compare-at-price'),
          $image = $(this).data('variantImage');
      $(this).siblings().removeClass('selected');
      $(this).addClass('selected');
      $(this).parents('.product-item__variants').find('.variant-selector').val($(this).data('variantId'));
      $container.find('.product-item__featured-image').attr('src', $image);
      checkPrice($price.text().replace(' USD', ''), Shopify.formatMoney($(this).data('variantPrice')), $price);
      checkPrice($compareprice.text().replace(' USD', ''), Shopify.formatMoney($(this).data('variantComparePrice')), $compareprice);
    }
  });
  
  jQuery('.product-item .add-to-cart').on('click', function(e){
    e.preventDefault();
    let $container = $(this).parents('.product-item'),
        $variantsContainer = $container.find('.product-item__variants'),
        $selectedVariant = $variantsContainer.find('.variant-selector'),
    	quantity = 1;
    Shopify.addItem({
      'id': $selectedVariant.val(),
      'quantity': quantity }
	);
  });
  
  /* Form validation JS */
  /*==========================*/

  $('input.error, textarea.error').focus(function() {
    $(this).removeClass('error');
  });

  $('form :submit').click(function() {
    $(this).parents('form').find('input.hint, textarea.hint').each(function() {
      $(this).val('').removeClass('hint');
    });
    return true;
  });
  
  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('.product-photo-thumb a').on('click', function(e) {
    e.preventDefault();
    switchImage($(this).attr('href'), null, $('.product-photo-container img')[0]);
  } );
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();
});

function notifyCustomer(product, variant_id, quantity){
  let product_data = jQuery.getJSON(product);
  product_data.done(function(){
    let image_id = "";
    let variant_image = "";
    let product_title = undefined;
    let product_price = undefined;
    let compare_at_price = undefined;
    if(product_data.responseJSON.product){
      product_data = product_data.responseJSON.product;
      if(product_data.variants.length > 1){
        for(var i = 0; i < product_data.variants.length; i++){
          if(variant_id == product_data.variants[i].id){
            image_id = product_data.variants[i].image_id;
            product_title = product_data.title + " - " + product_data.variants[i].title;
            product_price = product_data.variants[i].price;
            product_price = product_price.split('.');
            product_price = product_price.join('');
            let product_price_raw = parseInt(product_price);
            if(quantity > 1){
              product_price_raw = product_price_raw * quantity;
            }
            product_price = parseInt(product_price_raw);
            compare_at_price = product_data.variants[0].compare_at_price;
            compare_at_price = compare_at_price.split('.');
            compare_at_price = compare_at_price.join('');
            compare_at_price = parseInt(compare_at_price);
            product_price = validatePrice(product_price, compare_at_price ,product_data.tags);
            compare_at_price = validateComparePrice(product_price, product_price_raw, compare_at_price, product_data.tags);
            compare_at_price = Shopify.formatMoney(compare_at_price);
            product_price = Shopify.formatMoney(product_price);
          }
        }
        for(var i = 0; i < product_data.images.length; i++){
          if(image_id == product_data.images[i].id){
            variant_image = product_data.images[i].src;
            let lastPeriod = variant_image.lastIndexOf('.'),
                imageStringOne = variant_image.substring(0, lastPeriod),
                imageStringTwo = variant_image.substring(lastPeriod + 1);
            variant_image = imageStringOne + "_100x." + imageStringTwo;
          }
        }
      }else if(product_data.variants.length <= 1){
        variant_image = product_data.image.src;
        let lastPeriod = variant_image.lastIndexOf('.'),
            imageStringOne = variant_image.substring(0, lastPeriod),
            imageStringTwo = variant_image.substring(lastPeriod + 1);
        variant_image = imageStringOne + "_100x." + imageStringTwo;
        product_title = product_data.title;
        product_price = product_data.variants[0].price;
        product_price = product_price.split('.');
        product_price = product_price.join('');
        let product_price_raw = parseInt(product_price);
        if(quantity > 1){
          product_price_raw = product_price_raw * quantity;
        }
        product_price = parseInt(product_price_raw);
        compare_at_price = product_data.variants[0].compare_at_price;
        compare_at_price = compare_at_price.split('.');
        compare_at_price = compare_at_price.join('');
        compare_at_price = parseInt(compare_at_price);
        product_price = validatePrice(product_price, compare_at_price ,product_data.tags);
        compare_at_price = validateComparePrice(product_price, product_price_raw, compare_at_price, product_data.tags);
        compare_at_price = Shopify.formatMoney(compare_at_price);
        product_price = Shopify.formatMoney(product_price);
      }
    }
    let notification_container = '';
    let existing_notification = document.querySelectorAll('.atb-notification');
//     if(notification_container){
//       notification_container.remove();
//     }
    let notification_wrapper = generateElement('div','notification-wrapper');
    let notification_image = generateElement('div', 'notification-image');
    let notification_image__image = generateElement('img', 'notifcation-image__image');
    notification_image.appendChild(notification_image__image);
    let notification_title_price__container = generateElement('div','notification-title-price__container');
    let notification_title = generateElement('div','notification-title');
    let notification_price = generateElement('div','notification-price');
    notification_title_price__container.appendChild(notification_title);
    notification_title_price__container.appendChild(notification_price);
    let node_array = [notification_image, notification_title_price__container];

    appendNodeToParent(node_array);

    function generateElement(elementType, elementClass){
      let element = document.createElement(elementType);
      element.classList.add(elementClass);
      if (elementType === 'img'){
        element.src = variant_image;
      }
      if(elementClass === 'notification-title'){
        element.innerText = "You added " + product_title + " to your bag"; 
      }else if (elementClass === 'notification-price'){
        element.innerText = "x" + quantity + " " + product_price;
      }
      return element;
    }

    function appendNodeToParent(node){
      for(var i = 0; i < node.length; i++){
        notification_wrapper.appendChild(node[i]);
      }
    }

    notification_container = document.createElement('div');
    notification_container.classList.add('atb-notification');
    notification_container.appendChild(notification_wrapper);

    let body = document.getElementsByTagName('body');
    if(existing_notification){
      let top_position = document.getElementsByTagName('header')[0].offsetHeight;
      for(var i = 0; i < existing_notification.length; i++){
      	top_position = top_position + existing_notification[i].offsetHeight;
      }
      notification_container.style.top = top_position + "px";
      body[0].appendChild(notification_container);
    }else{
      let top_position = 0;
        top_position = top_position + document.getElementsByTagName('header')[0].offsetHeight;
        notification_container.style.top = top_position + "px";
    	body[0].appendChild(notification_container);
    }

    setTimeout(function(){
      notification_container.classList.add('atb-notification--active');
    }, 200);
    setTimeout(function(){
      notification_container.classList.remove('atb-notification--active');
        notification_container.remove();
    },3000);
  })
}

function startLoader(){
  let backdrop = createElement('div','class','loader-backdrop');
  let loadingCircle = createElement('div','class','loading-circle');
  let body = document.getElementsByTagName('body');
  backdrop.appendChild(loadingCircle);
  body[0].appendChild(backdrop);
}

function stopLoader(){
  let backdrop = document.querySelector('.loader-backdrop');
  if (backdrop){
    backdrop.remove();
  }
}


//function to create an element and set an initial attribute
function createElement(elementType, attributeType, attribute){
  let element = document.createElement(elementType);
  element.setAttribute(attributeType, attribute);
  return element;
}

//function to set multiple attributes on a created element
function assignAttributes(element, attributes, values){
  for(var i = 0; i < attributes.length; i++){
    element.setAttribute(attributes[i], values[i]);
  }
  return element;
}
function applySlider(settings){
    var slider = tns(settings);
}

// Show section when within window 

if ($(window).width()> 992){
  $(window).scroll(function(){

    var wScroll = $(this).scrollTop();
    $('.fade-in-onscroll').each(function(){
      if(wScroll > $(this).offset().top - ($(window).height()/8)){
        $(this).css({

          opacity:"1",
          transform: "translateY(0px)"

        });
      }
    });
  });
}else if ($(window).width()< 992){
  $(window).on('load', function(){

    $('.fade-in-onscroll').each(function(){
      $(this).css({

        opacity:"1",
        transform: "translateY(0px)"

      });
    });
  });
}

function validatePrice(price, compare_at_price, tags){
  let customerTags = document.getElementById('customer-tags').value;
  if(customerTags.indexOf('Professional') != -1 && tags.indexOf('exclude-scripts-discount') == -1){
    let discount = 0.6;
    if(compare_at_price > price){
      let current_discount_percentage = price / compare_at_price;
      if(tags.indexOf('clearance') == -1){
        if (current_discount_percentage >= 0.48 && current_discount_percentage <= 0.6){
          discount = 0.48;
          price = compare_at_price * discount;
        }else if (current_discount_percentage > 0.6){
          price = compare_at_price * discount;
        }
      } else {
        if(current_discount_percentage > 0.6){
          discount = 0.6;
          price = compare_at_price * discount;
        }else{
          return price;
        }
      }
    } else {
      if(tags.indexOf('chique') == -1){
        price = price * discount;
      }
    }
  }
  return price;
}

function validateComparePrice(validatedPrice, price, compare_at_price, tags){
  let customerTags = document.getElementById('customer-tags').value;
  if(tags.indexOf('sale') != -1 || tags.indexOf('clearance') != -1){
    return compare_at_price;
  }else{
    if(validatedPrice < price){
      return price;
    }else if(validatedPrice < compare_at_price){
      return compare_at_price;
    }else{
      return null;
    }
  }
}

function checkPrice(currentPrice, newPrice, container){
  if(currentPrice != newPrice){
    $(container).text(newPrice+' USD');
  }
}

function withinTimeframe(startDate, endDate){
  let currentDate = Date.now();
  if(typeof(startDate) == "string"){
    startDate = new Date(startDate).getTime();
  }
  if(typeof(endDate) == "string"){
    endDate = new Date(endDate).getTime();
  }
  if(startDate <= currentDate && currentDate <= endDate){
    return true;
  } else {
    return false;
  }
}


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}